export default __webpack_public_path__ + "static/FReg-Goal3-7cff765ee3f341312f62e7a7e05c6f48.jpg";